
const handleDataToggles = () => {
    const hideToggleGroupMembers = (toggleGroup) => {
        const members = document.querySelectorAll(`[data-toggle-group="${toggleGroup}"]`);
        for (const member of members) {
            if (member.getAttribute("transforms-on-toggle")) {
                member.classList.add("tw-opacity-0", "tw-scale-95");
            } else {
                member.classList.add("tw-hidden");
            }
        }
    }

    const toggleTarget = (targetSelector) => {
        let target = null;
        if (`${targetSelector}`.startsWith("#") || `${targetSelector}`.startsWith(".") || `${targetSelector}`.startsWith("[")) {
            target = document.querySelector(targetSelector);
        } else {
            target = document.getElementById(targetSelector);
        }

        if (!target) {
            console.warn(`data-toggle set for ${targetId} but target does not exist`);
        } else {
            const targetIsHidden = target.classList.contains("tw-hidden") || target.classList.contains("tw-opacity-0");
            const toggleGroup = target.getAttribute("data-toggle-group");
            if (toggleGroup) {
                hideToggleGroupMembers(toggleGroup);
            }

            if (targetIsHidden) {
                if (target.getAttribute("transforms-on-toggle")) {
                    target.classList.remove("tw-opacity-0", "tw-scale-95");
                    target.classList.add("tw-transform", "tw-opacity-100", "tw-scale-100");
                } else {
                    target.classList.remove("tw-hidden");
                }
            } else {
                if (target.getAttribute("transforms-on-toggle")) {
                    target.classList.add("tw-opacity-0", "tw-scale-95");
                    target.classList.remove("tw-transform", "tw-opacity-100", "tw-scale-100");
                } else {
                    target.classList.add("tw-hidden");
                }
            }
        }
    }

    const clickTogglers = document.querySelectorAll(`[data-toggle-with="click"]`);
    if (clickTogglers.length > 0) {
        for (const toggle of clickTogglers) {
            toggle.addEventListener("click", () => {
                const targetIds = toggle.getAttribute("data-toggle");
                targetIds.split(",").forEach(toggleTarget);
            });
        }
    }
};

document.addEventListener("DOMContentLoaded", function () {
    handleDataToggles();
});

/*

 Entering: "tw-duration-200 tw-ease-out"
      From: "tw-opacity-0 tw-scale-95"
      To: "tw-opacity-100 tw-scale-100"
    Leaving: "tw-duration-100 tw-ease-in"
      From: "tw-opacity-100 tw-scale-100"
      To: "tw-opacity-0 tw-scale-95"
*/